import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-indicators-single-data-modal',
  templateUrl: './indicators-single-data-modal.component.html',
  styleUrls: [
    './indicators-single-data-modal.component.scss',
    '../modal.scss'
  ]
})
export class IndicatorsSingleDataModalComponent implements OnInit {
  public loading: boolean = false;
  public new: boolean = false;
  public onSubmitEvent = new EventEmitter();
  public onDeleteEvent = new EventEmitter();

  public yearMask = [/[1-2]/, /\d/, /\d/, /\d/];

  public filteredOptions = [];

  @ViewChild("f", { static: true }) f: NgForm;
  constructor(
    public dialogRef: MatDialogRef<IndicatorsSingleDataModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { }

  onNoClick(e): void {
    //IF HAS DATA CONFIRM BEFORE CLOSE
    e.preventDefault();

    //ELSE, JUST CLOSE
    if (this.loading) {
      if (confirm("Você deseja cancelar a operação?")) {
        this.dialogRef.close(false);
      }
    } else
      this.dialogRef.close(false);
  }

  onSubmit(): void | boolean {
    this.loading = true;

    if (this.f.dirty) {
      this.onSubmitEvent.emit(this.data);
    } else {
      this.dialogRef.close(false);
    }
  }

  onDelete(): void | boolean {
    this.loading = true;

    // console.log(`onDelete: ${JSON.stringify(this.data)}`);

    if (confirm("Are you sure to delete? "))
      this.onDeleteEvent.emit(this.data);
    else
      this.loading = false;
  }

  public isDataSource(type: string): boolean {
    return type == "DATA_SOURCE";
  }

  public isYear(type: string): boolean {
    return type == "YEAR";
  }

  public isValue(type: string): boolean {
    return type == "VALUE";
  }

  public isObservation(type: string): boolean {
    return type == "OBSERVATION";
  }

  public isDeletable(): boolean {
    //IF IT DOES NOT HAVE A YEAR ATTIBUTE 
    var item = this.data.fields.filter(i => {
      return i.id === "VALUE";
    })[0];

    if (this.f.pristine && item && item['value'] === "") {
      this.new = true
    }

    return (!this.data.fields.some(j => j.id === 'YEAR') && !this.new);
  }

}